/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { ContentController } from "."
 */

/**
 * @param {ContentController} contentController
 * @returns {boolean}
 */
export function isLeafContentController(contentController) {
  return (
    contentController.type === 'empty' || contentController.type === 'medium'
  );
}
